const origin = typeof window === "undefined" ? "https://bottimo.methodius-realm.com" : window.location.origin;

export const config = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY ?? "https://auth.methodius-realm.com/realms/bottimo",
  clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? "bottimo-admin-ui",
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "/api").replace(/\/$/, ""),
  redirectUri: `${origin}/auth/callback`,
  postLogoutRedirectUri: origin,
};
